import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setDischargeField } from "../../../../Redux/actions/dischargeActions";

export default function FollowUp() {
  const dispatch = useDispatch();
  const followupDate = useSelector(
    (state) => state.discharge?.followupDate || ""
  );
  const followupDepartmentDesc = useSelector(
    (state) => state.discharge?.followupDepartmentDesc || "General Medicine"
  );
  const followupDoctorName = useSelector(
    (state) => state.discharge?.followupDoctorName || "Dr. Arun Kumar"
  );
  const followupInstruction = useSelector(
    (state) => state.discharge?.followupInstruction || ""
  );

  return (
    <div className="bg-white rounded-lg border border-gray-100 p-4 shadow-sm hover:shadow-md transition-shadow">
      <h3 className="text-sm font-bold text-teal-700 mb-3 flex items-center gap-2">
        <span className="w-2 h-2 rounded-full bg-teal-600"></span>
        8. Follow-up
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-3">
        <div>
          <label className="block text-xs font-semibold mb-1 text-gray-700">
            Follow-up Date <span className="text-red-500">*</span>
          </label>
          <input
            type="date"
            value={followupDate ? followupDate.substring(0, 10) : ""}
            onChange={(e) =>
              dispatch(
                setDischargeField(
                  "followupDate",
                  `${e.target.value} 10:00:00`
                )
              )
            }
            className="w-full text-xs border border-gray-200 rounded-md px-3 py-2 outline-none focus:border-teal-500 transition"
          />
        </div>
        {/* <div>
          <label className="block text-xs font-semibold mb-1 text-gray-700">
            Department <span className="text-red-500">*</span>
          </label>
          <select
            value={followupDepartmentDesc}
            onChange={(e) => {
              dispatch(setDischargeField("followupDepartmentDesc", e.target.value));
              dispatch(setDischargeField("followupDepartmentId", "DEPT001"));
            }}
            className="w-full text-xs border border-gray-200 rounded-md px-3 py-2 outline-none focus:border-teal-500 bg-white transition"
          >
            <option value="General Medicine">General Medicine</option>
            <option value="Cardiology">Cardiology</option>
            <option value="Orthopedics">Orthopedics</option>
            <option value="Pediatrics">Pediatrics</option>
            <option value="General Surgery">General Surgery</option>
          </select>
        </div> */}
        {/* <div className="sm:col-span-2">
          <label className="block text-xs font-semibold mb-1 text-gray-700">
            Doctor <span className="text-red-500">*</span>
          </label>
          <select
            value={followupDoctorName}
            onChange={(e) => {
              dispatch(setDischargeField("followupDoctorName", e.target.value));
              dispatch(setDischargeField("followupDoctorId", "DOC002"));
            }}
            className="w-full text-xs border border-gray-200 rounded-md px-3 py-2 outline-none focus:border-teal-500 bg-white transition"
          >
            <option value="Dr. Arun Kumar">Dr. Arun Kumar (DOC002)</option>
            <option value="Dr. Ramesh Kumar">Dr. Ramesh Kumar (DOC001)</option>
            <option value="Dr. Meera R">Dr. Meera R (DOC003)</option>
          </select>
        </div> */}
      </div>
      <div>
        <label className="block text-xs font-semibold mb-1 text-gray-700">
          Follow-up Instructions
        </label>
        <textarea
          value={followupInstruction}
          onChange={(e) =>
            dispatch(setDischargeField("followupInstruction", e.target.value))
          }
          className="w-full h-[70px] p-2.5 text-xs border border-gray-200 rounded-md outline-none focus:border-teal-500 resize-none transition"
          placeholder="e.g. Review after 7 days or earlier if symptoms worsen."
        ></textarea>
      </div>
    </div>
  );
}
